import domtoimage from '../tools/dom-to-image';
import jsPDF from "jspdf"
export default  {
    methods: {
        async printPage(selector='#carnotMainContent',customName=null,whiteMode= false){
            let target=document.querySelector(selector)
            let imgURL = await domtoimage.toJpeg(target, {
                quality: 0.95 ,
                bgcolor:whiteMode ? "#FFFFFF" : "#424242",
            })
            let doc = new jsPDF({ compress:true })
            doc.internal.pageSize.height=target.clientHeight
            doc.internal.pageSize.width=target.clientWidth
            doc.addImage(imgURL, 'JPEG', 0, 0, target.clientWidth, target.clientHeight, undefined, "FAST")
            if(customName){
                doc.save(customName+'.pdf')
            } else {
                doc.save('export.pdf')
            }
        },
    }
};